enum LineType {
  UNSET_LINE_TYPE = 'UNSET_LINE_TYPE', // Do not use, needed because of proto3 limitations
  LINE_TYPE_MIFI = 'LINE_TYPE_MIFI',
  LINE_TYPE_MOBILITY = 'LINE_TYPE_MOBILITY',
}

export { LineType as ReconciliatorLineType };
